exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/user/forgot-password/forgot-password.component.css
// module id = ../../../../../src/app/user/forgot-password/forgot-password.component.css
// module chunks = main